import React from "react";
import Layout from "../components/Layout";
import PreFooterCTA from "../components/PreFooterCTA";
import HeroSection from "../components/home/HeroSection";
import TrustBar from "../components/home/TrustBar";
import WhatWeFixSection from "../components/home/WhatWeFixSection";
import WhyChooseSection from "../components/home/WhyChooseSection";
import ProcessSection from "../components/home/ProcessSection";
import PortfolioSection from "../components/home/PortfolioSection";
import ServiceMapSection from "../components/home/ServiceMapSection";
import ReviewsSection from "../components/home/ReviewsSection";
import FaqSection from "../components/home/FaqSection";

export default function Home() {
  return (
    <Layout>
      <HeroSection />
      <TrustBar />
      <ReviewsSection />
      <WhatWeFixSection />
      <WhyChooseSection />
      <ProcessSection />
      <PortfolioSection />
      <ServiceMapSection />
      <FaqSection />
      <PreFooterCTA />
    </Layout>
  );
}
